import React, { createContext, useContext, useState, ReactNode } from 'react';
import { OnboardingStep } from 'src/types/onboardingStep';

interface OnboardingContextType {
  onboardingStep: OnboardingStep | null;
  setOnboardingStep: (step: OnboardingStep | null) => void;
}

interface OnboardingProviderProps {
  children: ReactNode;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(
  undefined
);

export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({
  children
}) => {
  const [onboardingStep, setOnboardingStep] = useState<OnboardingStep | null>(
    null
  );

  return (
    <OnboardingContext.Provider value={{ onboardingStep, setOnboardingStep }}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboardingContext = (): OnboardingContextType => {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error(
      'useOnboardingContext must be used within an OnboardingProvider'
    );
  }
  return context;
};
